import { useCallback, useMemo, useState } from 'react'
import type { NavigationCategory } from '../types/navigation'

export type PanelType = 'primary' | 'account' | 'navCategory'

export interface OpenPanelParams {
  panel: PanelType
  title: string
  id?: string
}

export function useMobileMenuNavigation(navigationData: NavigationCategory[]) {
  const [activePanel, setActivePanel] = useState<PanelType>('primary')
  const [activeNavId, setActiveNavId] = useState('')
  const [title, setTitle] = useState('')

  const activeNavData = useMemo(() => navigationData.find((category) => category.id === activeNavId), [navigationData, activeNavId])

  const openPanel = useCallback(({ panel, title, id }: OpenPanelParams) => {
    setActivePanel(panel)
    setTitle(title)
    if (id) setActiveNavId(id)
  }, [])

  const resetNavState = useCallback(() => {
    setTitle('')
    setActiveNavId('')
    setActivePanel('primary')
  }, [])

  return { activePanel, title, activeNavData, openPanel, resetNavState }
}
